import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  editDialog: {
    width: 632,
  },
  flexRow: {
    display: 'flex',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  helperText: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  bottomMarginSm: { marginBottom: theme.spacing(1) },
  reduceInputPadding: { padding: theme.spacing(1.25) },
  centerAlign: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowPadding: {
    paddingBottom: 30,
  },
  addMargin: {
    margin: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(4),
  },
  headerIcon: {
    height: 44,
    width: 44,
    margin: theme.spacing(0, 2, 1, 0),
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  reducedWidth: {
    maxWidth: '25%',
    minWidth: '25%',
  },
  inputLabel: { marginBottom: 4 },
  colDivider: {
    minHeight: 250,
    flexGrow: 1,
    margin: theme.spacing(2, 3),
    width: 2,
    maxWidth: 2,
    backgroundColor: theme.palette.border.light,
  },
  dollarAdornment: { paddingLeft: 0 },
  buttonPosition: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    margin: theme.spacing(3),
  },
  buttonText: {
    padding: theme.spacing(1, 2),
    textTransform: 'lowercase',
  },
  headerOverflow: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 350,
  },
  show: {
    opacity: 1,
    transition: 'opacity 300ms ease-in',
  },
  hide: {
    opacity: 0,
    transition: 'opacity 300ms ease-in',
  },
  headerBackground: {
    backgroundColor: theme.palette.background.default,
  },

  horizontalBorder: {
    border: `.5px solid ${theme.palette.border.main}`,
    margin: theme.spacing(0.5, 8, 0.5, 0),
  },
  radioBtnContainer: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 4,
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(1),
  },
  spendingPlanSelect: {
    marginBottom: 60,
  },
  dialogSize: {
    height: 400,
  },
}));

export default useStyles;
